// src/components/mindworkout/sections/WorkoutDetailSection.js
import React from 'react';
import styled from 'styled-components';

const SectionContainer = styled.section`
    padding: 5rem 2rem;
    background: white;
`;

const ContentWrapper = styled.div`
    max-width: 1200px;
    margin: 0 auto;
`;

const DetailGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4rem;
    align-items: center;
    margin-bottom: 4rem;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 2rem;
    }

    &:nth-child(even) {
        direction: rtl;

        @media (max-width: 768px) {
            direction: ltr;
        }
    }
`;

const TextContent = styled.div`
    direction: ltr;
`;

const DetailTitle = styled.h3`
    font-size: 2rem;
    margin-bottom: 1rem;
    color: #333;
`;

const DetailDescription = styled.p`
    font-size: 1.1rem;
    color: #666;
    line-height: 1.8;
    margin-bottom: 1.5rem;
`;

const FeatureList = styled.ul`
    list-style: none;
`;

const FeatureItem = styled.li`
    padding: 0.5rem 0;
    color: #555;
    display: flex;
    align-items: center;

    &::before {
        content: '✓';
        color: #4CAF50;
        font-weight: bold;
        margin-right: 0.5rem;
    }
`;

const ImageWrapper = styled.div`
    position: relative;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    max-width: 600px;  // 500px에서 600px로 증가
    margin: 0 auto;
`;

const StyledImage = styled.img`
    width: 100%;
    height: auto;
    display: block;
    max-height: 500px;  // 400px에서 500px로 증가
    object-fit: contain;  // cover에서 contain으로 변경하여 전체 이미지 보이도록
`;

const details = [
    {
        title: '게임처럼 재미있는 훈련',
        description: '지루한 명상이 아닌, 레벨업과 보상이 있는 게임화된 시스템으로 동기부여를 유지하세요.',
        features: ['레벨 시스템과 경험치', '일일 퀘스트와 도전 과제', '성취 배지와 리워드', '친구와 경쟁하기'],
        image: '/images/workout/mindworkout-gamification.jpg'
    },
    {
        title: '과학적 검증과 실시간 분석',
        description: 'CPT, SART 등 임상에서 사용되는 검증된 방법론을 기반으로 정확한 측정과 분석을 제공합니다.',
        features: ['실시간 성과 측정', '개인 맞춤 난이도 조절', '상세한 통계와 그래프', 'AI 기반 개선 제안'],
        image: '/images/workout/mindworkout-analytics.jpg'
    },
    {
        title: '단계별 체계적 커리큘럼',
        description: '초보자부터 고급자까지, 개인의 수준에 맞는 맞춤형 훈련 프로그램을 제공합니다.',
        features: ['22개의 다양한 훈련', '4개 영역 균형 발달', '점진적 난이도 상승', '개인별 약점 보완'],
        image: '/images/workout/mindworkout-curriculum.jpg'
    }
];

const WorkoutDetailSection = () => {
    return (
        <SectionContainer>
            <ContentWrapper>
                {details.map((detail, index) => (
                    <DetailGrid key={index}>
                        <TextContent>
                            <DetailTitle>{detail.title}</DetailTitle>
                            <DetailDescription>{detail.description}</DetailDescription>
                            <FeatureList>
                                {detail.features.map((feature, idx) => (
                                    <FeatureItem key={idx}>{feature}</FeatureItem>
                                ))}
                            </FeatureList>
                        </TextContent>
                        <ImageWrapper>
                            <StyledImage
                                src={detail.image}
                                alt={detail.title}
                            />
                        </ImageWrapper>
                    </DetailGrid>
                ))}
            </ContentWrapper>
        </SectionContainer>
    );
};

export default WorkoutDetailSection;
